export default __webpack_public_path__ + "static/media/arrow.15f67bef.svg";